import { NEWBUILDING_TRUST_AND_SAFETY } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const reliabilityEnabledSelector = (state: IApplicationState) => {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, NEWBUILDING_TRUST_AND_SAFETY, 'enabled');
};
